export default __webpack_public_path__ + "static/media/include_0@3x.d8491658.jpg";